import { useState } from 'react';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import EnergyChart from './EnergyChart';

export default function CombEnergyAdeSection({ site, startDate, endDate, msSessionInfo, refreshKey }) {
    const [expandedChart, setExpandedChart] = useState(null);

    const isEnergyExpanded = expandedChart === 'energy';
    const isAdeExpanded = expandedChart === 'ade';

    const handleEnergyToggle = () => {
        setExpandedChart(prev => {
            const next = prev === 'energy' ? null : 'energy';
            setTimeout(() => window.dispatchEvent(new Event('resize')), 100);
            return next;
        });
    };

    const handleAdeToggle = () => {
        setExpandedChart(prev => (prev === 'ade' ? null : 'ade'));
    };

    return (
        <Grid container spacing={3}>
            {/* <Grid
                item
                xs={12}
                md={isEnergyExpanded ? 12 : 6}
                lg={isEnergyExpanded ? 12 : 6}
                // style={{ display: isAdeExpanded ? 'none' : 'block' }}
            >
                <EnergyChart
                    key={`energy-${refreshKey}`}
                    site={site}
                    selectedDate={selectedDate}
                    msSessionInfo={msSessionInfo}
                    expandContractChart={handleEnergyToggle}
                    refreshKey={refreshKey}
                />
            </Grid> */}
            {!isAdeExpanded && (
                <Grid item xs={12} md={isEnergyExpanded ? 12 : 6} lg={isEnergyExpanded ? 12 : 6}>
                    <EnergyChart
                        key={`energy-${refreshKey}`}
                        site={site}
                        startDate={startDate}
                        endDate={endDate}
                        msSessionInfo={msSessionInfo}
                        expandContractChart={handleEnergyToggle}
                        refreshKey={refreshKey}
                    />
                </Grid>
            )}
        </Grid>
    );
}
CombEnergyAdeSection.propTypes = {
    site: PropTypes.object.isRequired,
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    msSessionInfo: PropTypes.object.isRequired,
    refreshKey: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
};

